import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.Basket {
  export interface IBasket {
    rows: IBasketRow[];
  }

  export interface ITrackingData {
    actionOrigin: string,
    searchProductOrigin:string
  }

  export interface IBasketRow {
    productId?: string;
    salesUnitCode?: string;
    rowId?: string;
    setQty?: number;
    changeQty?: number;
    trackingData?: ITrackingData;
    properties?: { [key: string]: string };
    purchaseType?: IPurchaseType;
    subscriptionOptions?: ISubscriptionOptions;
  }

  export interface BasketValidation {
    basketId: string;
    rowValidations: BasketRowValidation[];
    isValid: boolean;
  }

  export interface BasketRowValidation {
    basketRowId: string;
    errorCodes: string[];
    isValid: boolean;
  }

  export interface ISubscriptionOptions {
    optionId: string;
    qty?: number;
  }
  export enum IPurchaseType {
    OneTimePurchase,
    Subscription
  }
  export const UpdateBasket = async (data: IBasket, token: string): Promise<any> => {
    return await easyfyAxios.post('/api/basket?handler=save', data, token);
  };

  export const GetBasket = async (): Promise<any> => {
    return await easyfyAxios.get('/api/basket');
  }
}

export default Easyfy.Web.Services.Basket;